// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { addUpcomingInterest, autofillAgenda, completeActionItem, completeCalendarEvent, completeGoogleLogin, completeOnboarding, confirmActiveLabLogDraft, confirmAgendaItem, confirmReviewDocument, confirmStructuring, createAgendaItem, createAnalysis, createCalendarEvent, createGrant, createGroupCreationRequest, createGuestGrant, createHighlight, createMeeting, createOnboardingUpload, decideGroupCreationRequest, deleteActionItem, deleteActiveLabLogDraft, deleteCalendarEvent, deleteHighlight, deleteReadingListItem, deleteResearchEvent, dropActionItem, exchangeExtensionToken, excludeReviewDocument, exportUpcomingCalendar, extractMeetingActionItems, generateMinutes, getActiveLabLogDraft, getAnalysis, getBlocker, getDailyPick, getGroupCreationRequest, getGroupCreationRequestDetail, getHealth, getHighlight, getHighlightCitation, getInterestDraft, getInterestProfile, getLabDetail, getLastActivity, getMe, getMeeting, getMoreForYou, getOnboardingSession, getPaper, getUpcomingEvent, hideCalendarEvent, linkHighlightPaper, listAgendaItems, listCalendarItems, listConsents, listGroupCreationRequestQueue, listGroupCreationRequests, listHighlights, listKeywords, listMeetingActionItems, listMeetings, listMyLabs, listPapers, listReadingListItems, listResearchEvents, listReviewDocuments, listRevisions, listSubfields, listTopics, listUpcomingEvents, logout, logoutExtension, markActionItemPaperWrong, type Options, patchReviewDocument, putInterestDraft, queuePending, readGuestResource, recheckHighlight, removeUpcomingInterest, reopenActionItem, restoreReviewDocument, revokeGrant, revokeGuestGrant, saveActiveLabLogDraft, saveRecommendationToReadingList, saveResearchEvents, saveRevision, shareMeeting, startExtensionLogin, startGoogleLogin, submitConsents, unconfirmReviewDocument, unhideCalendarEvent, updateActionItem, updateCalendarEvent, updateGrant, updateHighlight, updateInterestProfile, updateMeeting, updateMinutes, updateReadingListItem, updateResearchEvent, wrapUpMeeting } from '../sdk.gen';
import type { AddUpcomingInterestData, AddUpcomingInterestResponse, AutofillAgendaData, AutofillAgendaResponse, CompleteActionItemData, CompleteActionItemResponse, CompleteCalendarEventData, CompleteCalendarEventResponse, CompleteGoogleLoginData, CompleteOnboardingData, CompleteOnboardingError, CompleteOnboardingResponse, ConfirmActiveLabLogDraftData, ConfirmActiveLabLogDraftResponse, ConfirmAgendaItemData, ConfirmAgendaItemResponse, ConfirmReviewDocumentData, ConfirmReviewDocumentResponse, ConfirmStructuringData, ConfirmStructuringResponse, CreateAgendaItemData, CreateAgendaItemResponse, CreateAnalysisData, CreateAnalysisResponse, CreateCalendarEventData, CreateCalendarEventResponse, CreateGrantData, CreateGrantResponse, CreateGroupCreationRequestData, CreateGroupCreationRequestResponse, CreateGuestGrantData, CreateGuestGrantResponse, CreateHighlightData, CreateHighlightResponse, CreateMeetingData, CreateMeetingResponse, CreateOnboardingUploadData, CreateOnboardingUploadResponse, DecideGroupCreationRequestData, DecideGroupCreationRequestResponse, DeleteActionItemData, DeleteActionItemResponse, DeleteActiveLabLogDraftData, DeleteActiveLabLogDraftResponse, DeleteCalendarEventData, DeleteCalendarEventResponse, DeleteHighlightData, DeleteHighlightResponse, DeleteReadingListItemData, DeleteReadingListItemResponse, DeleteResearchEventData, DeleteResearchEventResponse, DropActionItemData, DropActionItemResponse, ExchangeExtensionTokenData, ExchangeExtensionTokenResponse, ExcludeReviewDocumentData, ExcludeReviewDocumentResponse, ExportUpcomingCalendarData, ExportUpcomingCalendarResponse, ExtractMeetingActionItemsData, ExtractMeetingActionItemsResponse, GenerateMinutesData, GenerateMinutesResponse, GetActiveLabLogDraftData, GetActiveLabLogDraftResponse, GetAnalysisData, GetAnalysisResponse, GetBlockerData, GetBlockerResponse, GetDailyPickData, GetDailyPickResponse, GetGroupCreationRequestData, GetGroupCreationRequestDetailData, GetGroupCreationRequestDetailResponse, GetGroupCreationRequestResponse, GetHealthData, GetHealthResponse, GetHighlightCitationData, GetHighlightCitationResponse, GetHighlightData, GetHighlightResponse, GetInterestDraftData, GetInterestDraftResponse, GetInterestProfileData, GetInterestProfileResponse, GetLabDetailData, GetLabDetailResponse, GetLastActivityData, GetLastActivityResponse, GetMeData, GetMeetingData, GetMeetingResponse, GetMeResponse, GetMoreForYouData, GetMoreForYouResponse, GetOnboardingSessionData, GetOnboardingSessionResponse, GetPaperData, GetPaperResponse, GetUpcomingEventData, GetUpcomingEventResponse, HideCalendarEventData, HideCalendarEventResponse, LinkHighlightPaperData, LinkHighlightPaperResponse, ListAgendaItemsData, ListAgendaItemsResponse, ListCalendarItemsData, ListCalendarItemsResponse, ListConsentsData, ListConsentsResponse, ListGroupCreationRequestQueueData, ListGroupCreationRequestQueueResponse, ListGroupCreationRequestsData, ListGroupCreationRequestsResponse, ListHighlightsData, ListHighlightsResponse, ListKeywordsData, ListKeywordsResponse, ListMeetingActionItemsData, ListMeetingActionItemsResponse, ListMeetingsData, ListMeetingsResponse, ListMyLabsData, ListMyLabsResponse, ListPapersData, ListPapersResponse, ListReadingListItemsData, ListReadingListItemsResponse, ListResearchEventsData, ListResearchEventsResponse, ListReviewDocumentsData, ListReviewDocumentsResponse, ListRevisionsData, ListRevisionsResponse, ListSubfieldsData, ListSubfieldsResponse, ListTopicsData, ListTopicsResponse, ListUpcomingEventsData, ListUpcomingEventsResponse, LogoutData, LogoutExtensionData, LogoutExtensionResponse, LogoutResponse, MarkActionItemPaperWrongData, MarkActionItemPaperWrongResponse, PatchReviewDocumentData, PatchReviewDocumentResponse, PutInterestDraftData, PutInterestDraftResponse, QueuePendingData, QueuePendingResponse, ReadGuestResourceData, ReadGuestResourceResponse, RecheckHighlightData, RecheckHighlightResponse, RemoveUpcomingInterestData, RemoveUpcomingInterestResponse, ReopenActionItemData, ReopenActionItemResponse, RestoreReviewDocumentData, RestoreReviewDocumentResponse, RevokeGrantData, RevokeGrantResponse, RevokeGuestGrantData, RevokeGuestGrantResponse, SaveActiveLabLogDraftData, SaveActiveLabLogDraftResponse, SaveRecommendationToReadingListData, SaveRecommendationToReadingListResponse, SaveResearchEventsData, SaveResearchEventsResponse, SaveRevisionData, SaveRevisionResponse, ShareMeetingData, ShareMeetingResponse, StartExtensionLoginData, StartGoogleLoginData, SubmitConsentsData, SubmitConsentsResponse, UnconfirmReviewDocumentData, UnconfirmReviewDocumentResponse, UnhideCalendarEventData, UnhideCalendarEventResponse, UpdateActionItemData, UpdateActionItemResponse, UpdateCalendarEventData, UpdateCalendarEventResponse, UpdateGrantData, UpdateGrantResponse, UpdateHighlightData, UpdateHighlightResponse, UpdateInterestProfileData, UpdateInterestProfileError, UpdateInterestProfileResponse, UpdateMeetingData, UpdateMeetingResponse, UpdateMinutesData, UpdateMinutesResponse, UpdateReadingListItemData, UpdateReadingListItemResponse, UpdateResearchEventData, UpdateResearchEventResponse, WrapUpMeetingData, WrapUpMeetingResponse } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const startGoogleLoginQueryKey = (options?: Options<StartGoogleLoginData>) => createQueryKey('startGoogleLogin', options);

/**
 * Google 로그인 시작
 *
 * Google 인가 화면으로 302한다. `state`와 PKCE 검증값을 서버에 저장한다.
 */
export const startGoogleLoginOptions = (options?: Options<StartGoogleLoginData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof startGoogleLoginQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await startGoogleLogin({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: startGoogleLoginQueryKey(options)
});

export const completeGoogleLoginQueryKey = (options?: Options<CompleteGoogleLoginData>) => createQueryKey('completeGoogleLogin', options);

/**
 * Google 로그인 callback
 */
export const completeGoogleLoginOptions = (options?: Options<CompleteGoogleLoginData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof completeGoogleLoginQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await completeGoogleLogin({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: completeGoogleLoginQueryKey(options)
});

/**
 * 로그아웃 — 세션 회수와 쿠키 삭제
 */
export const logoutMutation = (options?: Partial<Options<LogoutData>>): UseMutationOptions<LogoutResponse, DefaultError, Options<LogoutData>> => {
    const mutationOptions: UseMutationOptions<LogoutResponse, DefaultError, Options<LogoutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await logout({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMeQueryKey = (options?: Options<GetMeData>) => createQueryKey('getMe', options);

/**
 * 내 계정 · 기관 소속 · 그룹 membership
 */
export const getMeOptions = (options?: Options<GetMeData>) => queryOptions<GetMeResponse, DefaultError, GetMeResponse, ReturnType<typeof getMeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMe({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMeQueryKey(options)
});

export const startExtensionLoginQueryKey = (options: Options<StartExtensionLoginData>) => createQueryKey('startExtensionLogin', options);

/**
 * 확장 로그인 시작
 *
 * 확장이 직접 연 로그인 창이 연다. 허용된 확장과 완료 페이지 redirect URI만 Google 인가로 302한다.
 */
export const startExtensionLoginOptions = (options: Options<StartExtensionLoginData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof startExtensionLoginQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await startExtensionLogin({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: startExtensionLoginQueryKey(options)
});

/**
 * 확장 토큰 — 한 번 코드 교환 · 갱신
 *
 * `DPoP` 증명 헤더가 필요하다. 응답은 `Cache-Control: no-store`다.
 */
export const exchangeExtensionTokenMutation = (options?: Partial<Options<ExchangeExtensionTokenData>>): UseMutationOptions<ExchangeExtensionTokenResponse, DefaultError, Options<ExchangeExtensionTokenData>> => {
    const mutationOptions: UseMutationOptions<ExchangeExtensionTokenResponse, DefaultError, Options<ExchangeExtensionTokenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await exchangeExtensionToken({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * 확장 로그아웃 — 갱신 토큰의 가족 회수
 *
 * 증명 키가 가족의 키와 같을 때만 회수한다. 무엇이 와도 `204`다.
 */
export const logoutExtensionMutation = (options?: Partial<Options<LogoutExtensionData>>): UseMutationOptions<LogoutExtensionResponse, DefaultError, Options<LogoutExtensionData>> => {
    const mutationOptions: UseMutationOptions<LogoutExtensionResponse, DefaultError, Options<LogoutExtensionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await logoutExtension({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listGroupCreationRequestsQueryKey = (options?: Options<ListGroupCreationRequestsData>) => createQueryKey('listGroupCreationRequests', options);

/**
 * 내 Lab 생성 신청 목록
 */
export const listGroupCreationRequestsOptions = (options?: Options<ListGroupCreationRequestsData>) => queryOptions<ListGroupCreationRequestsResponse, DefaultError, ListGroupCreationRequestsResponse, ReturnType<typeof listGroupCreationRequestsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listGroupCreationRequests({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listGroupCreationRequestsQueryKey(options)
});

/**
 * 최초 Lab 생성 신청
 */
export const createGroupCreationRequestMutation = (options?: Partial<Options<CreateGroupCreationRequestData>>): UseMutationOptions<CreateGroupCreationRequestResponse, DefaultError, Options<CreateGroupCreationRequestData>> => {
    const mutationOptions: UseMutationOptions<CreateGroupCreationRequestResponse, DefaultError, Options<CreateGroupCreationRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createGroupCreationRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getGroupCreationRequestQueryKey = (options: Options<GetGroupCreationRequestData>) => createQueryKey('getGroupCreationRequest', options);

/**
 * 내 Lab 생성 신청 상세
 */
export const getGroupCreationRequestOptions = (options: Options<GetGroupCreationRequestData>) => queryOptions<GetGroupCreationRequestResponse, DefaultError, GetGroupCreationRequestResponse, ReturnType<typeof getGroupCreationRequestQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getGroupCreationRequest({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getGroupCreationRequestQueryKey(options)
});

export const listGroupCreationRequestQueueQueryKey = (options?: Options<ListGroupCreationRequestQueueData>) => createQueryKey('listGroupCreationRequestQueue', options);

/**
 * Lab 생성 신청 대기열 (운영자 전용)
 */
export const listGroupCreationRequestQueueOptions = (options?: Options<ListGroupCreationRequestQueueData>) => queryOptions<ListGroupCreationRequestQueueResponse, DefaultError, ListGroupCreationRequestQueueResponse, ReturnType<typeof listGroupCreationRequestQueueQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listGroupCreationRequestQueue({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listGroupCreationRequestQueueQueryKey(options)
});

export const getGroupCreationRequestDetailQueryKey = (options: Options<GetGroupCreationRequestDetailData>) => createQueryKey('getGroupCreationRequestDetail', options);

/**
 * Lab 생성 신청 상세 (운영자 전용)
 */
export const getGroupCreationRequestDetailOptions = (options: Options<GetGroupCreationRequestDetailData>) => queryOptions<GetGroupCreationRequestDetailResponse, DefaultError, GetGroupCreationRequestDetailResponse, ReturnType<typeof getGroupCreationRequestDetailQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getGroupCreationRequestDetail({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getGroupCreationRequestDetailQueryKey(options)
});

/**
 * Lab 생성 신청 승인·거절 (운영자 전용)
 */
export const decideGroupCreationRequestMutation = (options?: Partial<Options<DecideGroupCreationRequestData>>): UseMutationOptions<DecideGroupCreationRequestResponse, DefaultError, Options<DecideGroupCreationRequestData>> => {
    const mutationOptions: UseMutationOptions<DecideGroupCreationRequestResponse, DefaultError, Options<DecideGroupCreationRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await decideGroupCreationRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getHealthQueryKey = (options?: Options<GetHealthData>) => createQueryKey('getHealth', options);

/**
 * 서비스 상태 및 서버 기준 시각
 *
 * compose healthcheck와 운영 점검이 사용한다.
 */
export const getHealthOptions = (options?: Options<GetHealthData>) => queryOptions<GetHealthResponse, DefaultError, GetHealthResponse, ReturnType<typeof getHealthQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHealth({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHealthQueryKey(options)
});

export const listConsentsQueryKey = (options?: Options<ListConsentsData>) => createQueryKey('listConsents', options);

/**
 * 현행 동의 문서와 내 동의 상태
 */
export const listConsentsOptions = (options?: Options<ListConsentsData>) => queryOptions<ListConsentsResponse, DefaultError, ListConsentsResponse, ReturnType<typeof listConsentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listConsents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listConsentsQueryKey(options)
});

/**
 * 항목별 동의·철회를 한 번에 제출
 */
export const submitConsentsMutation = (options?: Partial<Options<SubmitConsentsData>>): UseMutationOptions<SubmitConsentsResponse, DefaultError, Options<SubmitConsentsData>> => {
    const mutationOptions: UseMutationOptions<SubmitConsentsResponse, DefaultError, Options<SubmitConsentsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await submitConsents({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * 온보딩 자료 업로드 (파일 1개)
 */
export const createOnboardingUploadMutation = (options?: Partial<Options<CreateOnboardingUploadData>>): UseMutationOptions<CreateOnboardingUploadResponse, DefaultError, Options<CreateOnboardingUploadData>> => {
    const mutationOptions: UseMutationOptions<CreateOnboardingUploadResponse, DefaultError, Options<CreateOnboardingUploadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createOnboardingUpload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getOnboardingSessionQueryKey = (options?: Options<GetOnboardingSessionData>) => createQueryKey('getOnboardingSession', options);

/**
 * 온보딩 진행 상태
 */
export const getOnboardingSessionOptions = (options?: Options<GetOnboardingSessionData>) => queryOptions<GetOnboardingSessionResponse, DefaultError, GetOnboardingSessionResponse, ReturnType<typeof getOnboardingSessionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOnboardingSession({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOnboardingSessionQueryKey(options)
});

/**
 * 온보딩 문서 분석 시작 (멱등) — E16 §7
 */
export const createAnalysisMutation = (options?: Partial<Options<CreateAnalysisData>>): UseMutationOptions<CreateAnalysisResponse, DefaultError, Options<CreateAnalysisData>> => {
    const mutationOptions: UseMutationOptions<CreateAnalysisResponse, DefaultError, Options<CreateAnalysisData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createAnalysis({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAnalysisQueryKey = (options: Options<GetAnalysisData>) => createQueryKey('getAnalysis', options);

/**
 * 온보딩 문서 분석 상태 조회 — E16 §7
 */
export const getAnalysisOptions = (options: Options<GetAnalysisData>) => queryOptions<GetAnalysisResponse, DefaultError, GetAnalysisResponse, ReturnType<typeof getAnalysisQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAnalysis({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAnalysisQueryKey(options)
});

export const listReviewDocumentsQueryKey = (options?: Options<ListReviewDocumentsData>) => createQueryKey('listReviewDocuments', options);

/**
 * 검토 문서 목록
 */
export const listReviewDocumentsOptions = (options?: Options<ListReviewDocumentsData>) => queryOptions<ListReviewDocumentsResponse, DefaultError, ListReviewDocumentsResponse, ReturnType<typeof listReviewDocumentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listReviewDocuments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listReviewDocumentsQueryKey(options)
});

/**
 * 검토 문서의 수정 가능 필드 저장
 */
export const patchReviewDocumentMutation = (options?: Partial<Options<PatchReviewDocumentData>>): UseMutationOptions<PatchReviewDocumentResponse, DefaultError, Options<PatchReviewDocumentData>> => {
    const mutationOptions: UseMutationOptions<PatchReviewDocumentResponse, DefaultError, Options<PatchReviewDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchReviewDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * 검토 문서 확인 해제
 */
export const unconfirmReviewDocumentMutation = (options?: Partial<Options<UnconfirmReviewDocumentData>>): UseMutationOptions<UnconfirmReviewDocumentResponse, DefaultError, Options<UnconfirmReviewDocumentData>> => {
    const mutationOptions: UseMutationOptions<UnconfirmReviewDocumentResponse, DefaultError, Options<UnconfirmReviewDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await unconfirmReviewDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * 검토 문서 확인
 */
export const confirmReviewDocumentMutation = (options?: Partial<Options<ConfirmReviewDocumentData>>): UseMutationOptions<ConfirmReviewDocumentResponse, DefaultError, Options<ConfirmReviewDocumentData>> => {
    const mutationOptions: UseMutationOptions<ConfirmReviewDocumentResponse, DefaultError, Options<ConfirmReviewDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await confirmReviewDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * 검토 문서 제외 복구
 */
export const restoreReviewDocumentMutation = (options?: Partial<Options<RestoreReviewDocumentData>>): UseMutationOptions<RestoreReviewDocumentResponse, DefaultError, Options<RestoreReviewDocumentData>> => {
    const mutationOptions: UseMutationOptions<RestoreReviewDocumentResponse, DefaultError, Options<RestoreReviewDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await restoreReviewDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * 검토 문서 제외
 */
export const excludeReviewDocumentMutation = (options?: Partial<Options<ExcludeReviewDocumentData>>): UseMutationOptions<ExcludeReviewDocumentResponse, DefaultError, Options<ExcludeReviewDocumentData>> => {
    const mutationOptions: UseMutationOptions<ExcludeReviewDocumentResponse, DefaultError, Options<ExcludeReviewDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await excludeReviewDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * 온보딩 성과·관심 프로필 원자적 확정
 */
export const completeOnboardingMutation = (options?: Partial<Options<CompleteOnboardingData>>): UseMutationOptions<CompleteOnboardingResponse, CompleteOnboardingError, Options<CompleteOnboardingData>> => {
    const mutationOptions: UseMutationOptions<CompleteOnboardingResponse, CompleteOnboardingError, Options<CompleteOnboardingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await completeOnboarding({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getInterestDraftQueryKey = (options?: Options<GetInterestDraftData>) => createQueryKey('getInterestDraft', options);

/**
 * 온보딩 관심 연구 분야 초안 조회
 */
export const getInterestDraftOptions = (options?: Options<GetInterestDraftData>) => queryOptions<GetInterestDraftResponse, DefaultError, GetInterestDraftResponse, ReturnType<typeof getInterestDraftQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getInterestDraft({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getInterestDraftQueryKey(options)
});

/**
 * 온보딩 관심 연구 분야 초안 저장
 */
export const putInterestDraftMutation = (options?: Partial<Options<PutInterestDraftData>>): UseMutationOptions<PutInterestDraftResponse, DefaultError, Options<PutInterestDraftData>> => {
    const mutationOptions: UseMutationOptions<PutInterestDraftResponse, DefaultError, Options<PutInterestDraftData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putInterestDraft({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getInterestProfileQueryKey = (options?: Options<GetInterestProfileData>) => createQueryKey('getInterestProfile', options);

/**
 * 현재 관심 연구 분야 조회
 */
export const getInterestProfileOptions = (options?: Options<GetInterestProfileData>) => queryOptions<GetInterestProfileResponse, DefaultError, GetInterestProfileResponse, ReturnType<typeof getInterestProfileQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getInterestProfile({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getInterestProfileQueryKey(options)
});

/**
 * 관심 연구 분야 확정
 */
export const updateInterestProfileMutation = (options?: Partial<Options<UpdateInterestProfileData>>): UseMutationOptions<UpdateInterestProfileResponse, UpdateInterestProfileError, Options<UpdateInterestProfileData>> => {
    const mutationOptions: UseMutationOptions<UpdateInterestProfileResponse, UpdateInterestProfileError, Options<UpdateInterestProfileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateInterestProfile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listSubfieldsQueryKey = (options?: Options<ListSubfieldsData>) => createQueryKey('listSubfields', options);

export const listSubfieldsOptions = (options?: Options<ListSubfieldsData>) => queryOptions<ListSubfieldsResponse, DefaultError, ListSubfieldsResponse, ReturnType<typeof listSubfieldsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listSubfields({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listSubfieldsQueryKey(options)
});

export const listTopicsQueryKey = (options?: Options<ListTopicsData>) => createQueryKey('listTopics', options);

export const listTopicsOptions = (options?: Options<ListTopicsData>) => queryOptions<ListTopicsResponse, DefaultError, ListTopicsResponse, ReturnType<typeof listTopicsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listTopics({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listTopicsQueryKey(options)
});

export const listKeywordsQueryKey = (options?: Options<ListKeywordsData>) => createQueryKey('listKeywords', options);

export const listKeywordsOptions = (options?: Options<ListKeywordsData>) => queryOptions<ListKeywordsResponse, DefaultError, ListKeywordsResponse, ReturnType<typeof listKeywordsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listKeywords({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listKeywordsQueryKey(options)
});

export const queuePendingMutation = (options?: Partial<Options<QueuePendingData>>): UseMutationOptions<QueuePendingResponse, DefaultError, Options<QueuePendingData>> => {
    const mutationOptions: UseMutationOptions<QueuePendingResponse, DefaultError, Options<QueuePendingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await queuePending({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getLastActivityQueryKey = (options?: Options<GetLastActivityData>) => createQueryKey('getLastActivity', options);

export const getLastActivityOptions = (options?: Options<GetLastActivityData>) => queryOptions<GetLastActivityResponse, DefaultError, GetLastActivityResponse, ReturnType<typeof getLastActivityQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getLastActivity({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getLastActivityQueryKey(options)
});

export const listResearchEventsQueryKey = (options?: Options<ListResearchEventsData>) => createQueryKey('listResearchEvents', options);

export const listResearchEventsOptions = (options?: Options<ListResearchEventsData>) => queryOptions<ListResearchEventsResponse, DefaultError, ListResearchEventsResponse, ReturnType<typeof listResearchEventsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listResearchEvents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listResearchEventsQueryKey(options)
});

export const saveResearchEventsMutation = (options?: Partial<Options<SaveResearchEventsData>>): UseMutationOptions<SaveResearchEventsResponse, DefaultError, Options<SaveResearchEventsData>> => {
    const mutationOptions: UseMutationOptions<SaveResearchEventsResponse, DefaultError, Options<SaveResearchEventsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await saveResearchEvents({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteResearchEventMutation = (options?: Partial<Options<DeleteResearchEventData>>): UseMutationOptions<DeleteResearchEventResponse, DefaultError, Options<DeleteResearchEventData>> => {
    const mutationOptions: UseMutationOptions<DeleteResearchEventResponse, DefaultError, Options<DeleteResearchEventData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteResearchEvent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const updateResearchEventMutation = (options?: Partial<Options<UpdateResearchEventData>>): UseMutationOptions<UpdateResearchEventResponse, DefaultError, Options<UpdateResearchEventData>> => {
    const mutationOptions: UseMutationOptions<UpdateResearchEventResponse, DefaultError, Options<UpdateResearchEventData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateResearchEvent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteActiveLabLogDraftMutation = (options?: Partial<Options<DeleteActiveLabLogDraftData>>): UseMutationOptions<DeleteActiveLabLogDraftResponse, DefaultError, Options<DeleteActiveLabLogDraftData>> => {
    const mutationOptions: UseMutationOptions<DeleteActiveLabLogDraftResponse, DefaultError, Options<DeleteActiveLabLogDraftData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteActiveLabLogDraft({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getActiveLabLogDraftQueryKey = (options?: Options<GetActiveLabLogDraftData>) => createQueryKey('getActiveLabLogDraft', options);

export const getActiveLabLogDraftOptions = (options?: Options<GetActiveLabLogDraftData>) => queryOptions<GetActiveLabLogDraftResponse, DefaultError, GetActiveLabLogDraftResponse, ReturnType<typeof getActiveLabLogDraftQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getActiveLabLogDraft({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getActiveLabLogDraftQueryKey(options)
});

export const saveActiveLabLogDraftMutation = (options?: Partial<Options<SaveActiveLabLogDraftData>>): UseMutationOptions<SaveActiveLabLogDraftResponse, DefaultError, Options<SaveActiveLabLogDraftData>> => {
    const mutationOptions: UseMutationOptions<SaveActiveLabLogDraftResponse, DefaultError, Options<SaveActiveLabLogDraftData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await saveActiveLabLogDraft({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const confirmActiveLabLogDraftMutation = (options?: Partial<Options<ConfirmActiveLabLogDraftData>>): UseMutationOptions<ConfirmActiveLabLogDraftResponse, DefaultError, Options<ConfirmActiveLabLogDraftData>> => {
    const mutationOptions: UseMutationOptions<ConfirmActiveLabLogDraftResponse, DefaultError, Options<ConfirmActiveLabLogDraftData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await confirmActiveLabLogDraft({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getBlockerQueryKey = (options: Options<GetBlockerData>) => createQueryKey('getBlocker', options);

export const getBlockerOptions = (options: Options<GetBlockerData>) => queryOptions<GetBlockerResponse, DefaultError, GetBlockerResponse, ReturnType<typeof getBlockerQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getBlocker({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getBlockerQueryKey(options)
});

export const confirmStructuringMutation = (options?: Partial<Options<ConfirmStructuringData>>): UseMutationOptions<ConfirmStructuringResponse, DefaultError, Options<ConfirmStructuringData>> => {
    const mutationOptions: UseMutationOptions<ConfirmStructuringResponse, DefaultError, Options<ConfirmStructuringData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await confirmStructuring({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listMeetingsQueryKey = (options?: Options<ListMeetingsData>) => createQueryKey('listMeetings', options);

export const listMeetingsOptions = (options?: Options<ListMeetingsData>) => queryOptions<ListMeetingsResponse, DefaultError, ListMeetingsResponse, ReturnType<typeof listMeetingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listMeetings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listMeetingsQueryKey(options)
});

export const createMeetingMutation = (options?: Partial<Options<CreateMeetingData>>): UseMutationOptions<CreateMeetingResponse, DefaultError, Options<CreateMeetingData>> => {
    const mutationOptions: UseMutationOptions<CreateMeetingResponse, DefaultError, Options<CreateMeetingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createMeeting({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMeetingQueryKey = (options: Options<GetMeetingData>) => createQueryKey('getMeeting', options);

export const getMeetingOptions = (options: Options<GetMeetingData>) => queryOptions<GetMeetingResponse, DefaultError, GetMeetingResponse, ReturnType<typeof getMeetingQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMeeting({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMeetingQueryKey(options)
});

export const updateMeetingMutation = (options?: Partial<Options<UpdateMeetingData>>): UseMutationOptions<UpdateMeetingResponse, DefaultError, Options<UpdateMeetingData>> => {
    const mutationOptions: UseMutationOptions<UpdateMeetingResponse, DefaultError, Options<UpdateMeetingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateMeeting({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const shareMeetingMutation = (options?: Partial<Options<ShareMeetingData>>): UseMutationOptions<ShareMeetingResponse, DefaultError, Options<ShareMeetingData>> => {
    const mutationOptions: UseMutationOptions<ShareMeetingResponse, DefaultError, Options<ShareMeetingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await shareMeeting({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listAgendaItemsQueryKey = (options: Options<ListAgendaItemsData>) => createQueryKey('listAgendaItems', options);

export const listAgendaItemsOptions = (options: Options<ListAgendaItemsData>) => queryOptions<ListAgendaItemsResponse, DefaultError, ListAgendaItemsResponse, ReturnType<typeof listAgendaItemsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listAgendaItems({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAgendaItemsQueryKey(options)
});

export const createAgendaItemMutation = (options?: Partial<Options<CreateAgendaItemData>>): UseMutationOptions<CreateAgendaItemResponse, DefaultError, Options<CreateAgendaItemData>> => {
    const mutationOptions: UseMutationOptions<CreateAgendaItemResponse, DefaultError, Options<CreateAgendaItemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createAgendaItem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const autofillAgendaMutation = (options?: Partial<Options<AutofillAgendaData>>): UseMutationOptions<AutofillAgendaResponse, DefaultError, Options<AutofillAgendaData>> => {
    const mutationOptions: UseMutationOptions<AutofillAgendaResponse, DefaultError, Options<AutofillAgendaData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await autofillAgenda({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const updateMinutesMutation = (options?: Partial<Options<UpdateMinutesData>>): UseMutationOptions<UpdateMinutesResponse, DefaultError, Options<UpdateMinutesData>> => {
    const mutationOptions: UseMutationOptions<UpdateMinutesResponse, DefaultError, Options<UpdateMinutesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateMinutes({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const generateMinutesMutation = (options?: Partial<Options<GenerateMinutesData>>): UseMutationOptions<GenerateMinutesResponse, DefaultError, Options<GenerateMinutesData>> => {
    const mutationOptions: UseMutationOptions<GenerateMinutesResponse, DefaultError, Options<GenerateMinutesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await generateMinutes({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const wrapUpMeetingMutation = (options?: Partial<Options<WrapUpMeetingData>>): UseMutationOptions<WrapUpMeetingResponse, DefaultError, Options<WrapUpMeetingData>> => {
    const mutationOptions: UseMutationOptions<WrapUpMeetingResponse, DefaultError, Options<WrapUpMeetingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await wrapUpMeeting({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const extractMeetingActionItemsMutation = (options?: Partial<Options<ExtractMeetingActionItemsData>>): UseMutationOptions<ExtractMeetingActionItemsResponse, DefaultError, Options<ExtractMeetingActionItemsData>> => {
    const mutationOptions: UseMutationOptions<ExtractMeetingActionItemsResponse, DefaultError, Options<ExtractMeetingActionItemsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await extractMeetingActionItems({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listMeetingActionItemsQueryKey = (options: Options<ListMeetingActionItemsData>) => createQueryKey('listMeetingActionItems', options);

export const listMeetingActionItemsOptions = (options: Options<ListMeetingActionItemsData>) => queryOptions<ListMeetingActionItemsResponse, DefaultError, ListMeetingActionItemsResponse, ReturnType<typeof listMeetingActionItemsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listMeetingActionItems({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listMeetingActionItemsQueryKey(options)
});

export const confirmAgendaItemMutation = (options?: Partial<Options<ConfirmAgendaItemData>>): UseMutationOptions<ConfirmAgendaItemResponse, DefaultError, Options<ConfirmAgendaItemData>> => {
    const mutationOptions: UseMutationOptions<ConfirmAgendaItemResponse, DefaultError, Options<ConfirmAgendaItemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await confirmAgendaItem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteActionItemMutation = (options?: Partial<Options<DeleteActionItemData>>): UseMutationOptions<DeleteActionItemResponse, DefaultError, Options<DeleteActionItemData>> => {
    const mutationOptions: UseMutationOptions<DeleteActionItemResponse, DefaultError, Options<DeleteActionItemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteActionItem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const updateActionItemMutation = (options?: Partial<Options<UpdateActionItemData>>): UseMutationOptions<UpdateActionItemResponse, DefaultError, Options<UpdateActionItemData>> => {
    const mutationOptions: UseMutationOptions<UpdateActionItemResponse, DefaultError, Options<UpdateActionItemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateActionItem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const markActionItemPaperWrongMutation = (options?: Partial<Options<MarkActionItemPaperWrongData>>): UseMutationOptions<MarkActionItemPaperWrongResponse, DefaultError, Options<MarkActionItemPaperWrongData>> => {
    const mutationOptions: UseMutationOptions<MarkActionItemPaperWrongResponse, DefaultError, Options<MarkActionItemPaperWrongData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await markActionItemPaperWrong({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const completeActionItemMutation = (options?: Partial<Options<CompleteActionItemData>>): UseMutationOptions<CompleteActionItemResponse, DefaultError, Options<CompleteActionItemData>> => {
    const mutationOptions: UseMutationOptions<CompleteActionItemResponse, DefaultError, Options<CompleteActionItemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await completeActionItem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const dropActionItemMutation = (options?: Partial<Options<DropActionItemData>>): UseMutationOptions<DropActionItemResponse, DefaultError, Options<DropActionItemData>> => {
    const mutationOptions: UseMutationOptions<DropActionItemResponse, DefaultError, Options<DropActionItemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await dropActionItem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const reopenActionItemMutation = (options?: Partial<Options<ReopenActionItemData>>): UseMutationOptions<ReopenActionItemResponse, DefaultError, Options<ReopenActionItemData>> => {
    const mutationOptions: UseMutationOptions<ReopenActionItemResponse, DefaultError, Options<ReopenActionItemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await reopenActionItem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listCalendarItemsQueryKey = (options?: Options<ListCalendarItemsData>) => createQueryKey('listCalendarItems', options);

export const listCalendarItemsOptions = (options?: Options<ListCalendarItemsData>) => queryOptions<ListCalendarItemsResponse, DefaultError, ListCalendarItemsResponse, ReturnType<typeof listCalendarItemsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listCalendarItems({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listCalendarItemsQueryKey(options)
});

export const createCalendarEventMutation = (options?: Partial<Options<CreateCalendarEventData>>): UseMutationOptions<CreateCalendarEventResponse, DefaultError, Options<CreateCalendarEventData>> => {
    const mutationOptions: UseMutationOptions<CreateCalendarEventResponse, DefaultError, Options<CreateCalendarEventData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createCalendarEvent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteCalendarEventMutation = (options?: Partial<Options<DeleteCalendarEventData>>): UseMutationOptions<DeleteCalendarEventResponse, DefaultError, Options<DeleteCalendarEventData>> => {
    const mutationOptions: UseMutationOptions<DeleteCalendarEventResponse, DefaultError, Options<DeleteCalendarEventData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteCalendarEvent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const updateCalendarEventMutation = (options?: Partial<Options<UpdateCalendarEventData>>): UseMutationOptions<UpdateCalendarEventResponse, DefaultError, Options<UpdateCalendarEventData>> => {
    const mutationOptions: UseMutationOptions<UpdateCalendarEventResponse, DefaultError, Options<UpdateCalendarEventData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateCalendarEvent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const completeCalendarEventMutation = (options?: Partial<Options<CompleteCalendarEventData>>): UseMutationOptions<CompleteCalendarEventResponse, DefaultError, Options<CompleteCalendarEventData>> => {
    const mutationOptions: UseMutationOptions<CompleteCalendarEventResponse, DefaultError, Options<CompleteCalendarEventData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await completeCalendarEvent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const unhideCalendarEventMutation = (options?: Partial<Options<UnhideCalendarEventData>>): UseMutationOptions<UnhideCalendarEventResponse, DefaultError, Options<UnhideCalendarEventData>> => {
    const mutationOptions: UseMutationOptions<UnhideCalendarEventResponse, DefaultError, Options<UnhideCalendarEventData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await unhideCalendarEvent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const hideCalendarEventMutation = (options?: Partial<Options<HideCalendarEventData>>): UseMutationOptions<HideCalendarEventResponse, DefaultError, Options<HideCalendarEventData>> => {
    const mutationOptions: UseMutationOptions<HideCalendarEventResponse, DefaultError, Options<HideCalendarEventData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await hideCalendarEvent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listMyLabsQueryKey = (options?: Options<ListMyLabsData>) => createQueryKey('listMyLabs', options);

export const listMyLabsOptions = (options?: Options<ListMyLabsData>) => queryOptions<ListMyLabsResponse, DefaultError, ListMyLabsResponse, ReturnType<typeof listMyLabsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listMyLabs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listMyLabsQueryKey(options)
});

export const getLabDetailQueryKey = (options: Options<GetLabDetailData>) => createQueryKey('getLabDetail', options);

export const getLabDetailOptions = (options: Options<GetLabDetailData>) => queryOptions<GetLabDetailResponse, DefaultError, GetLabDetailResponse, ReturnType<typeof getLabDetailQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getLabDetail({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getLabDetailQueryKey(options)
});

export const createGrantMutation = (options?: Partial<Options<CreateGrantData>>): UseMutationOptions<CreateGrantResponse, DefaultError, Options<CreateGrantData>> => {
    const mutationOptions: UseMutationOptions<CreateGrantResponse, DefaultError, Options<CreateGrantData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createGrant({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const revokeGrantMutation = (options?: Partial<Options<RevokeGrantData>>): UseMutationOptions<RevokeGrantResponse, DefaultError, Options<RevokeGrantData>> => {
    const mutationOptions: UseMutationOptions<RevokeGrantResponse, DefaultError, Options<RevokeGrantData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await revokeGrant({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const updateGrantMutation = (options?: Partial<Options<UpdateGrantData>>): UseMutationOptions<UpdateGrantResponse, DefaultError, Options<UpdateGrantData>> => {
    const mutationOptions: UseMutationOptions<UpdateGrantResponse, DefaultError, Options<UpdateGrantData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateGrant({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listRevisionsQueryKey = (options: Options<ListRevisionsData>) => createQueryKey('listRevisions', options);

export const listRevisionsOptions = (options: Options<ListRevisionsData>) => queryOptions<ListRevisionsResponse, DefaultError, ListRevisionsResponse, ReturnType<typeof listRevisionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listRevisions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listRevisionsQueryKey(options)
});

export const saveRevisionMutation = (options?: Partial<Options<SaveRevisionData>>): UseMutationOptions<SaveRevisionResponse, DefaultError, Options<SaveRevisionData>> => {
    const mutationOptions: UseMutationOptions<SaveRevisionResponse, DefaultError, Options<SaveRevisionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await saveRevision({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const createGuestGrantMutation = (options?: Partial<Options<CreateGuestGrantData>>): UseMutationOptions<CreateGuestGrantResponse, DefaultError, Options<CreateGuestGrantData>> => {
    const mutationOptions: UseMutationOptions<CreateGuestGrantResponse, DefaultError, Options<CreateGuestGrantData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createGuestGrant({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const revokeGuestGrantMutation = (options?: Partial<Options<RevokeGuestGrantData>>): UseMutationOptions<RevokeGuestGrantResponse, DefaultError, Options<RevokeGuestGrantData>> => {
    const mutationOptions: UseMutationOptions<RevokeGuestGrantResponse, DefaultError, Options<RevokeGuestGrantData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await revokeGuestGrant({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const readGuestResourceQueryKey = (options: Options<ReadGuestResourceData>) => createQueryKey('readGuestResource', options);

export const readGuestResourceOptions = (options: Options<ReadGuestResourceData>) => queryOptions<ReadGuestResourceResponse, DefaultError, ReadGuestResourceResponse, ReturnType<typeof readGuestResourceQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await readGuestResource({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: readGuestResourceQueryKey(options)
});

export const getDailyPickQueryKey = (options?: Options<GetDailyPickData>) => createQueryKey('getDailyPick', options);

export const getDailyPickOptions = (options?: Options<GetDailyPickData>) => queryOptions<GetDailyPickResponse, DefaultError, GetDailyPickResponse, ReturnType<typeof getDailyPickQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDailyPick({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDailyPickQueryKey(options)
});

export const getMoreForYouQueryKey = (options?: Options<GetMoreForYouData>) => createQueryKey('getMoreForYou', options);

export const getMoreForYouOptions = (options?: Options<GetMoreForYouData>) => queryOptions<GetMoreForYouResponse, DefaultError, GetMoreForYouResponse, ReturnType<typeof getMoreForYouQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMoreForYou({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMoreForYouQueryKey(options)
});

export const listReadingListItemsQueryKey = (options?: Options<ListReadingListItemsData>) => createQueryKey('listReadingListItems', options);

export const listReadingListItemsOptions = (options?: Options<ListReadingListItemsData>) => queryOptions<ListReadingListItemsResponse, DefaultError, ListReadingListItemsResponse, ReturnType<typeof listReadingListItemsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listReadingListItems({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listReadingListItemsQueryKey(options)
});

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const listReadingListItemsInfiniteQueryKey = (options?: Options<ListReadingListItemsData>): QueryKey<Options<ListReadingListItemsData>> => createQueryKey('listReadingListItems', options, true);

export const listReadingListItemsInfiniteOptions = (options?: Options<ListReadingListItemsData>) => {
    const opts = infiniteQueryOptions<ListReadingListItemsResponse, DefaultError, InfiniteData<ListReadingListItemsResponse>, QueryKey<Options<ListReadingListItemsData>>, string | Pick<QueryKey<Options<ListReadingListItemsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListReadingListItemsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listReadingListItems({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listReadingListItemsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const deleteReadingListItemMutation = (options?: Partial<Options<DeleteReadingListItemData>>): UseMutationOptions<DeleteReadingListItemResponse, DefaultError, Options<DeleteReadingListItemData>> => {
    const mutationOptions: UseMutationOptions<DeleteReadingListItemResponse, DefaultError, Options<DeleteReadingListItemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteReadingListItem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const updateReadingListItemMutation = (options?: Partial<Options<UpdateReadingListItemData>>): UseMutationOptions<UpdateReadingListItemResponse, DefaultError, Options<UpdateReadingListItemData>> => {
    const mutationOptions: UseMutationOptions<UpdateReadingListItemResponse, DefaultError, Options<UpdateReadingListItemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateReadingListItem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const saveRecommendationToReadingListMutation = (options?: Partial<Options<SaveRecommendationToReadingListData>>): UseMutationOptions<SaveRecommendationToReadingListResponse, DefaultError, Options<SaveRecommendationToReadingListData>> => {
    const mutationOptions: UseMutationOptions<SaveRecommendationToReadingListResponse, DefaultError, Options<SaveRecommendationToReadingListData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await saveRecommendationToReadingList({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listPapersQueryKey = (options?: Options<ListPapersData>) => createQueryKey('listPapers', options);

export const listPapersOptions = (options?: Options<ListPapersData>) => queryOptions<ListPapersResponse, DefaultError, ListPapersResponse, ReturnType<typeof listPapersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPapers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPapersQueryKey(options)
});

export const listPapersInfiniteQueryKey = (options?: Options<ListPapersData>): QueryKey<Options<ListPapersData>> => createQueryKey('listPapers', options, true);

export const listPapersInfiniteOptions = (options?: Options<ListPapersData>) => {
    const opts = infiniteQueryOptions<ListPapersResponse, DefaultError, InfiniteData<ListPapersResponse>, QueryKey<Options<ListPapersData>>, string | Pick<QueryKey<Options<ListPapersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListPapersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listPapers({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listPapersInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getPaperQueryKey = (options: Options<GetPaperData>) => createQueryKey('getPaper', options);

export const getPaperOptions = (options: Options<GetPaperData>) => queryOptions<GetPaperResponse, DefaultError, GetPaperResponse, ReturnType<typeof getPaperQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPaper({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPaperQueryKey(options)
});

export const listHighlightsQueryKey = (options?: Options<ListHighlightsData>) => createQueryKey('listHighlights', options);

export const listHighlightsOptions = (options?: Options<ListHighlightsData>) => queryOptions<ListHighlightsResponse, DefaultError, ListHighlightsResponse, ReturnType<typeof listHighlightsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listHighlights({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listHighlightsQueryKey(options)
});

export const listHighlightsInfiniteQueryKey = (options?: Options<ListHighlightsData>): QueryKey<Options<ListHighlightsData>> => createQueryKey('listHighlights', options, true);

export const listHighlightsInfiniteOptions = (options?: Options<ListHighlightsData>) => {
    const opts = infiniteQueryOptions<ListHighlightsResponse, DefaultError, InfiniteData<ListHighlightsResponse>, QueryKey<Options<ListHighlightsData>>, string | Pick<QueryKey<Options<ListHighlightsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListHighlightsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listHighlights({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listHighlightsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const createHighlightMutation = (options?: Partial<Options<CreateHighlightData>>): UseMutationOptions<CreateHighlightResponse, DefaultError, Options<CreateHighlightData>> => {
    const mutationOptions: UseMutationOptions<CreateHighlightResponse, DefaultError, Options<CreateHighlightData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createHighlight({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteHighlightMutation = (options?: Partial<Options<DeleteHighlightData>>): UseMutationOptions<DeleteHighlightResponse, DefaultError, Options<DeleteHighlightData>> => {
    const mutationOptions: UseMutationOptions<DeleteHighlightResponse, DefaultError, Options<DeleteHighlightData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteHighlight({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getHighlightQueryKey = (options: Options<GetHighlightData>) => createQueryKey('getHighlight', options);

export const getHighlightOptions = (options: Options<GetHighlightData>) => queryOptions<GetHighlightResponse, DefaultError, GetHighlightResponse, ReturnType<typeof getHighlightQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHighlight({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHighlightQueryKey(options)
});

export const updateHighlightMutation = (options?: Partial<Options<UpdateHighlightData>>): UseMutationOptions<UpdateHighlightResponse, DefaultError, Options<UpdateHighlightData>> => {
    const mutationOptions: UseMutationOptions<UpdateHighlightResponse, DefaultError, Options<UpdateHighlightData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateHighlight({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const linkHighlightPaperMutation = (options?: Partial<Options<LinkHighlightPaperData>>): UseMutationOptions<LinkHighlightPaperResponse, DefaultError, Options<LinkHighlightPaperData>> => {
    const mutationOptions: UseMutationOptions<LinkHighlightPaperResponse, DefaultError, Options<LinkHighlightPaperData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await linkHighlightPaper({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const recheckHighlightMutation = (options?: Partial<Options<RecheckHighlightData>>): UseMutationOptions<RecheckHighlightResponse, DefaultError, Options<RecheckHighlightData>> => {
    const mutationOptions: UseMutationOptions<RecheckHighlightResponse, DefaultError, Options<RecheckHighlightData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await recheckHighlight({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getHighlightCitationQueryKey = (options: Options<GetHighlightCitationData>) => createQueryKey('getHighlightCitation', options);

export const getHighlightCitationOptions = (options: Options<GetHighlightCitationData>) => queryOptions<GetHighlightCitationResponse, DefaultError, GetHighlightCitationResponse, ReturnType<typeof getHighlightCitationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHighlightCitation({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHighlightCitationQueryKey(options)
});

export const listUpcomingEventsQueryKey = (options?: Options<ListUpcomingEventsData>) => createQueryKey('listUpcomingEvents', options);

export const listUpcomingEventsOptions = (options?: Options<ListUpcomingEventsData>) => queryOptions<ListUpcomingEventsResponse, DefaultError, ListUpcomingEventsResponse, ReturnType<typeof listUpcomingEventsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listUpcomingEvents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listUpcomingEventsQueryKey(options)
});

export const listUpcomingEventsInfiniteQueryKey = (options?: Options<ListUpcomingEventsData>): QueryKey<Options<ListUpcomingEventsData>> => createQueryKey('listUpcomingEvents', options, true);

export const listUpcomingEventsInfiniteOptions = (options?: Options<ListUpcomingEventsData>) => {
    const opts = infiniteQueryOptions<ListUpcomingEventsResponse, DefaultError, InfiniteData<ListUpcomingEventsResponse>, QueryKey<Options<ListUpcomingEventsData>>, string | Pick<QueryKey<Options<ListUpcomingEventsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListUpcomingEventsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listUpcomingEvents({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listUpcomingEventsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getUpcomingEventQueryKey = (options: Options<GetUpcomingEventData>) => createQueryKey('getUpcomingEvent', options);

export const getUpcomingEventOptions = (options: Options<GetUpcomingEventData>) => queryOptions<GetUpcomingEventResponse, DefaultError, GetUpcomingEventResponse, ReturnType<typeof getUpcomingEventQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUpcomingEvent({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUpcomingEventQueryKey(options)
});

export const exportUpcomingCalendarQueryKey = (options: Options<ExportUpcomingCalendarData>) => createQueryKey('exportUpcomingCalendar', options);

export const exportUpcomingCalendarOptions = (options: Options<ExportUpcomingCalendarData>) => queryOptions<ExportUpcomingCalendarResponse, DefaultError, ExportUpcomingCalendarResponse, ReturnType<typeof exportUpcomingCalendarQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await exportUpcomingCalendar({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: exportUpcomingCalendarQueryKey(options)
});

export const removeUpcomingInterestMutation = (options?: Partial<Options<RemoveUpcomingInterestData>>): UseMutationOptions<RemoveUpcomingInterestResponse, DefaultError, Options<RemoveUpcomingInterestData>> => {
    const mutationOptions: UseMutationOptions<RemoveUpcomingInterestResponse, DefaultError, Options<RemoveUpcomingInterestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeUpcomingInterest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const addUpcomingInterestMutation = (options?: Partial<Options<AddUpcomingInterestData>>): UseMutationOptions<AddUpcomingInterestResponse, DefaultError, Options<AddUpcomingInterestData>> => {
    const mutationOptions: UseMutationOptions<AddUpcomingInterestResponse, DefaultError, Options<AddUpcomingInterestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addUpcomingInterest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
